// `colors` option is a function !
const getColor = (i, pct) => {
  if (pct > 0.75) {
    return '#355e3b'
  } else if (pct >= 0.65) {
    return 'rgb(168,208,142)'
  } else if (pct >= 0.55) {
    return '#AAA'
  } else if (pct >= 0.45) {
    return '#ffea00'
  } else if (pct < 0.45) {
    return '#8b0000'
  }
}

export default getColor



// WEBPACK FOOTER //
// ./src/helpers/getColorFromPercentage.js